module.exports = __webpack_public_path__ + "img/programme_icon_gongyinglian.77198b19.png";